import * as z from "zod";
import {
  BillOfMaterialsListItem,
  billOfMaterialsStatusSchema,
} from "./bill-of-materials-types";

const GetBillOfMaterialsListInput_ = z.object({
  status: billOfMaterialsStatusSchema.optional(),
  page: z.number().int().min(1).optional(),
  pageSize: z.number().int().min(1).max(200).optional(),
});
export const GetBillOfMaterialsListInput: z.ZodType<GetBillOfMaterialsListInput> =
  GetBillOfMaterialsListInput_;
export interface GetBillOfMaterialsListInput extends z.infer<
  typeof GetBillOfMaterialsListInput_
> {}

export const getBillOfMaterialsList = {
  name: "getBillOfMaterialsList" as const,
  input: GetBillOfMaterialsListInput,
  output: z.object({
    items: z.array(BillOfMaterialsListItem),
    totalCount: z.number(),
  }),
};
